import { css } from "@emotion/react";
import { vars } from "@imwebme/clay-token";

export const baseCss = css({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",

  cursor: "pointer",
  "&:focus": {
    outline: "none",
  },
});

export const fullWidthCss = css({
  width: "100%",
});

export const withTextCss = css({
  gap: vars.spacing[2],
});

export const sizeStyles = {
  medium: css`
    padding: ${vars.spacing[2]} ${vars.spacing[3]};
    border-radius: ${vars.rounded.medium};
    ${vars.semantic.typography["label-medium-bold"]}
    svg {
      font-size: 20px;
    }
  `,
  large: css`
    padding: ${vars.spacing[3]};
    border-radius: ${vars.rounded.medium};
    ${vars.semantic.typography["label-large-bold"]}
    svg {
      font-size: 24px;
    }
  `,
  "medium-icon": css`
    padding: ${vars.spacing[25]};
    border-radius: ${vars.rounded.full};

    svg {
      font-size: 20px;
    }
  `,
  "large-icon": css`
    padding: ${vars.spacing[3]};
    border-radius: ${vars.rounded.full};

    svg {
      font-size: 24px;
    }
  `,
};

export const socialVariants = {
  naver: css({
    color: "#FFF",
    background: "#03C75A",
    "&:hover": {
      background:
        "linear-gradient(0deg, rgba(0, 0, 0, 0.10) 0%, rgba(0, 0, 0, 0.10) 100%), #03C75A",
    },
    "&:active": {
      background:
        "linear-gradient(0deg, rgba(0, 0, 0, 0.30) 0%, rgba(0, 0, 0, 0.30) 100%), #03C75A",
    },
  }),
  kakao: css({
    color: "rgba(0, 0, 0, 0.85)",
    background: "#FEE500",
    "&:hover": {
      background:
        "linear-gradient(0deg, rgba(0, 0, 0, 0.04) 0%, rgba(0, 0, 0, 0.04) 100%), #FEE500",
    },
    "&:active": {
      background:
        "linear-gradient(0deg, rgba(0, 0, 0, 0.08) 0%, rgba(0, 0, 0, 0.08) 100%), #FEE500",
    },
  }),
  google: css({
    color: vars.semantic.color.textSecondary,
    background: vars.semantic.color.actionSecondary,
    boxShadow: `inset 0 0 0 1px ${vars.semantic.color.border}`,
    "&:hover": {
      boxShadow: `inset 0 0 0 1px ${vars.semantic.color.borderHover}`,
    },
    "&:active": {
      boxShadow: `inset 0 0 0 1px ${vars.semantic.color.borderSub}`,
    },
  }),
  apple: css({
    color: vars.semantic.color.textSecondary,
    background: vars.semantic.color.actionSecondary,
    svg: {
      color: "#000",
    },
    // 애플 로고 다크모드 대응
    '*[data-clay-theme="dark-only"] &': {
      svg: {
        color: "#FFF",
      },
    },
    boxShadow: `inset 0 0 0 1px ${vars.semantic.color.border}`,
    "&:hover": {
      boxShadow: `inset 0 0 0 1px ${vars.semantic.color.borderHover}`,
    },
    "&:active": {
      boxShadow: `inset 0 0 0 1px ${vars.semantic.color.borderSub}`,
    },
  }),
  line: css({
    color: "#FFF",
    background: "#06C755",
    "&:hover": {
      background:
        "linear-gradient(0deg, rgba(0, 0, 0, 0.10) 0%, rgba(0, 0, 0, 0.10) 100%), #06C755",
    },
    "&:active": {
      background:
        "linear-gradient(0deg, rgba(0, 0, 0, 0.30) 0%, rgba(0, 0, 0, 0.30) 100%), #06C755",
    },
  }),
  facebook: css({
    color: "#FFF",
    background: "#1877F2",
    "&:hover": {
      background:
        "linear-gradient(0deg, rgba(0, 0, 0, 0.10) 0%, rgba(0, 0, 0, 0.10) 100%), #1877F2",
    },
    "&:active": {
      background:
        "linear-gradient(0deg, rgba(0, 0, 0, 0.15) 0%, rgba(0, 0, 0, 0.15) 100%), #1877F2",
    },
  }),
};
